var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoreeEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25754 15.849L17.3987 0.708313C18.3433 -0.235969 19.875 -0.23624 20.8194 0.708313L23.3113 3.20038C24.2559 4.14506 24.2559 5.6767 23.3113 6.62139L8.17017 21.7621C7.90466 22.0276 7.58096 22.2277 7.22471 22.3464L2.57266 23.8972C1.05838 24.402 -0.382227 22.9613 0.122525 21.4469L1.6732 16.7945C1.79196 16.4383 1.99202 16.1145 2.25754 15.849ZM15.8457 4.31784L19.7005 8.17286L7.14122 20.733C7.03543 20.8388 6.90647 20.9185 6.76454 20.9659L2.11249 22.5167C1.73581 22.6422 1.37745 22.2838 1.50301 21.9071L3.05369 17.2547C3.101 17.1128 3.18071 16.9838 3.28649 16.878L15.8457 4.31784ZM22.2824 5.59236L20.7228 7.15082L16.8681 3.2958L18.4276 1.73734C18.804 1.36097 19.4141 1.36097 19.7905 1.73734L22.2824 4.22941C22.6587 4.60577 22.6587 5.21599 22.2824 5.59236Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoreeEdit);
export default __webpack_public_path__ + "static/media/loree-edit.fcf388892eeb89199e3cb84e1553c52c.svg";
export { ForwardRef as ReactComponent };